import { useTranslation } from '@mint-lib/i18n';
import { Divider, Switch, SwitchLabel } from '@mint-lib/tw-components';

import BarContainer from './components/BarContainer.jsx';
import ManageFlightsBtn from './components/ManageFlightsBtn.jsx';
import RowActionsAndExport from './components/RowActionsAndExport.jsx';
import SendOrderBtn from './components/SendOrderBtn.jsx';

const ActivityActionBar = () => {
  const { t } = useTranslation('@myn/planning_v2');

  return (
    <BarContainer>
      <div className="flex gap-2">
        <ManageFlightsBtn />
        <SendOrderBtn />
      </div>
      <div className="flex items-center gap-2">
        <SwitchLabel disabled>
          <Switch size="small" disabled />

          {t('Carbon offset')}
        </SwitchLabel>

        <Divider orientation="vertical" />
        <RowActionsAndExport />
      </div>
    </BarContainer>
  );
};

export default ActivityActionBar;
